import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("si_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function formatApiError(err) {
  if (err == null) return "Something went wrong. Please try again.";

  // If an Axios error was passed directly, unwrap to response.data.detail
  let detail = err;
  if (err.isAxiosError || err.response) {
    detail = err?.response?.data?.detail ?? err?.response?.data ?? err.message ?? err;
  }

  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => {
        if (!e) return "";
        if (typeof e === "string") return e;
        const field = Array.isArray(e.loc) ? e.loc.slice(1).join(".") : "";   // loc[0] is usually "body"
        const msg = e.msg || JSON.stringify(e);
        return field ? `${field}: ${msg}` : msg;
      })
      .filter(Boolean)
      .join(" · ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail.message === "string") return detail.message;
  return String(detail);
}

/** Prefix a relative `/api/...` path with REACT_APP_BACKEND_URL so it works
 *  on custom domains where the page origin and the API host may differ.
 *  Passes through http(s) URLs and data: URLs untouched. */
export function absoluteUrl(path) {
  if (!path) return "";
  if (/^(https?:|data:|blob:)/i.test(path)) return path;
  return `${BACKEND_URL}${path}`;
}

